import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import PropTypes from 'prop-types';
import EditInterviewModal from '../../EditInterviewModal';
import ConfirmableLink from '../../ConfirmableLink';
import './InterviewActions.scss';
var InterviewActions = /*#__PURE__*/function (_React$Component) {
  function InterviewActions(props) {
    var _this;
    _classCallCheck(this, InterviewActions);
    _this = _callSuper(this, InterviewActions, [props]);
    _this.state = {
      showCancellationCopy: false
    };
    return _this;
  }
  _inherits(InterviewActions, _React$Component);
  return _createClass(InterviewActions, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var showCancellationCopy = this.state.showCancellationCopy;
      var _this$props = this.props,
        interview = _this$props.interview,
        interviewType = _this$props.interviewType,
        editInterviewPath = _this$props.editInterviewPath,
        csrfToken = _this$props.csrfToken,
        possibleInterviewers = _this$props.possibleInterviewers,
        invitableRoles = _this$props.invitableRoles,
        canEdit = _this$props.canEdit,
        canCancel = _this$props.canCancel,
        location = _this$props.location,
        editModalRef = _this$props.editModalRef,
        resheduleModalRef = _this$props.resheduleModalRef,
        onCancel = _this$props.onCancel,
        repOrOwner = _this$props.repOrOwner,
        availableInterviewSlotUrl = _this$props.availableInterviewSlotUrl;
      return /*#__PURE__*/React.createElement("div", {
        className: "style-guide pending-interview-actions-container body-text-2 medium-weight muted-gray-text d-flex flex-column flex-md-row gap-3 justify-content-between"
      }, showCancellationCopy ? /*#__PURE__*/React.createElement("div", {
        className: "normal-weight"
      }, "Do you want to cancel this call?") : repOrOwner && interviewType === 'upcoming' ? /*#__PURE__*/React.createElement(EditInterviewModal, {
        editInterviewPath: editInterviewPath,
        csrfToken: csrfToken,
        possibleInterviewers: possibleInterviewers,
        invitableRoles: invitableRoles,
        interview: interview,
        resheduleModalRef: resheduleModalRef,
        location: location,
        interviewType: interviewType,
        availableInterviewSlotUrl: availableInterviewSlotUrl,
        interviewReschedule: true
      }) : /*#__PURE__*/React.createElement("div", {
        className: "normal-weight"
      }, "Need to modify?"), /*#__PURE__*/React.createElement("div", {
        className: "d-flex flex-column flex-md-row gap-3"
      }, !showCancellationCopy && canEdit && /*#__PURE__*/React.createElement(EditInterviewModal, {
        editInterviewPath: editInterviewPath,
        csrfToken: csrfToken,
        possibleInterviewers: possibleInterviewers,
        invitableRoles: invitableRoles,
        interview: interview,
        editModalRef: editModalRef,
        location: location,
        interviewType: interviewType,
        disableAvailabilitySelection: interviewType === 'upcoming',
        availableInterviewSlotUrl: availableInterviewSlotUrl
      }), canCancel && /*#__PURE__*/React.createElement(ConfirmableLink, {
        spaceBetween: "10px",
        linkClassName: "medium-weight body-text-2 warning-text",
        triggerCTA: "Cancel",
        confirmCTA: "Yes",
        cancelCTA: "No",
        showCopy: false,
        onSubmit: onCancel,
        onClickTrigger: function onClickTrigger() {
          return _this2.setState({
            showCancellationCopy: true
          });
        },
        onClickCancel: function onClickCancel() {
          return _this2.setState({
            showCancellationCopy: false
          });
        }
      })));
    }
  }]);
}(React.Component);
InterviewActions.propTypes = {
  editInterviewPath: PropTypes.string.isRequired,
  canCancel: PropTypes.bool,
  canEdit: PropTypes.bool,
  possibleInterviewers: PropTypes.shape({
    current_user_permission: PropTypes.shape({}),
    team_members: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  invitableRoles: PropTypes.arrayOf(PropTypes.string).isRequired,
  interview: PropTypes.shape({}).isRequired,
  csrfToken: PropTypes.string.isRequired,
  location: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  editModalRef: PropTypes.func,
  resheduleModalRef: PropTypes.func,
  interviewType: PropTypes.string.isRequired,
  repOrOwner: PropTypes.bool,
  availableInterviewSlotUrl: PropTypes.string.isRequired
};
InterviewActions.defaultProps = {
  location: 'Location Unspecified',
  canCancel: false,
  canEdit: false,
  editModalRef: function editModalRef() {
    return null;
  },
  resheduleModalRef: function resheduleModalRef() {
    return null;
  },
  repOrOwner: false
};
export default InterviewActions;